module.exports = __webpack_public_path__ + "img/confirma-convenio.f828a32a.png";